import React, { FC } from 'react';
import classNames from 'classnames';
import { Connect, PropsFromRedux } from './DesktopTypeItemContainer';
import { buildUrlWithParameters } from '../../../../utils/url-utils/urlUtils';
import styles from './desktop_type_item.module.scss';
import { Hyperlink } from '../../../../components/Hyperlink';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';

type Props = PropsFromRedux &
  UserContextType &
  WithRestrictedModalProps & {
    onTypeChanged: (
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => void;
  };

export const RawDesktopTypeItem: FC<Props> = ({
  url,
  selected,
  onTypeChanged,
  children,
  accessPremium,
  openRestrictedModal,
}) => (
  <Hyperlink
    data-test-id="search-type"
    {...(accessPremium
      ? {
          href: buildUrlWithParameters(url, {
            source: 'search-types',
          }),
          onClick: onTypeChanged,
        }
      : {
          onClick: () => openRestrictedModal('search-types'),
        })}
    className={classNames(styles.item, selected && styles.selectedItem)}
  >
    {children}
  </Hyperlink>
);

export const DesktopTypeItem = Connect(
  withUser(withRestrictedModal(RawDesktopTypeItem)),
);
